import { create } from 'zustand'
export const useVisibilityByBeneficiaryStore = create(set => ({
  barsValue: 0,
  setBarsValue: value => set(() => ({ barsValue: value })),

  barsPData: [],
  setBarsPData: data => set(() => ({ barsPData: data })),

  barsXLabels: [],
  setBarsXLabels: labels => set(() => ({ barsXLabels: labels })),

  searchPhone: '',
  setSearchPhone: phone => set(() => ({ searchPhone: phone })),

  searchReference: '',
  setSearchReference: reference => set(() => ({ searchReference: reference })),

  searchUserReference: '',
  setSearchUserReference: userReference =>
    set(() => ({ searchUserReference: userReference })),

  dateExpiryStart: '',
  setDateExpiryStart: date => set(() => ({ dateExpiryStart: date })),

  dateExpiryEnd: '',
  setDateExpiryEnd: date => set(() => ({ dateExpiryEnd: date })),

  walletID: '',
  setWalletID: id => set(() => ({ walletID: id })),

  walletCreditedBalanceData: [],
  setWalletCreditedBalanceData: data =>
    set(() => ({ walletCreditedBalanceData: data })),

  expandedRows: {},
  setExpandedRow: (index, isOpen) =>
    set(state => ({
      expandedRows: { ...state.expandedRows, [index]: isOpen },
    })),
  userHavePermission: false,
  setUserHavePermission: bool => set(() => ({ userHavePermission: bool })),

  transactions: [],
  setTransactions: data => set(() => ({ transactions: data })),

  resetStore: () =>
    set(() => ({
      barsValue: 0,
      barsPData: [],
      barsXLabels: [],
      searchPhone: '',
      dateExpiryStart: '',
      dateExpiryEnd: '',
      walletID: '',
      walletCreditedBalanceData: [],
      expandedRows: {},
    })),
}))
